<template>
    <div
        class="hint"
        v-click-outside="
            () => {
                isOpen = false;
            }
        ">
        <div class="hint__icon text_9" @click="isOpen = !isOpen">?</div>
        <transition name="fade">
            <div class="hint__text" v-if="isOpen" v-html="hint"></div>
        </transition>
    </div>
</template>
<script>
export default {
    name: "Hint",
    props: ["hint"],
    data() {
        return {
            isOpen: false,
        };
    },
};
</script>
<style lang="less">
.hint {
    display: inline-block;
    vertical-align: middle;
    margin-left: 4px;
    position: relative;
    white-space: nowrap;
    text-align: center;
    @media @sm {
        white-space: normal;
    }
    &__icon {
        position: relative;
        letter-spacing: 0;
        width: 12px;
        height: 12px;
        line-height: 12px;
        background: @border2;
        color: #000;
        cursor: pointer;
        padding-left: 1px;
        .trs(all);
        .is_apple & {
            padding-top: 1px;
        }
        &:hover {
            background: #000;
            color: #fff;
        }
    }
    &__text {
        position: absolute;
        bottom: 100%;
        right: 0;
        padding: 16px 24px;
        color: #fff;
        background: @text_3;
        ul {
            width: 290px;
            text-align: left;
            li {
                white-space: normal;
                display: flex;
                &:before {
                    content: "—";
                    margin-right: 5px;
                }
                + li {
                    margin-top: 4px;
                }
            }
        }
        @media @sm {
            white-space: normal;
            width: calc(100vw - 32px);
        }
    }
}
</style>
